var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-footer',{attrs:{"color":"heavy-rain-gradient"}},[_c('p',{staticClass:"footer-copyright mb-0 py-2 pr-2 text-right text-white"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" TRADECOM Digital Solutions GmbH ")])])}
var staticRenderFns = []

export { render, staticRenderFns }